'use client';

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import useLoginModal from "../hooks/useLoginModal";

export default function ClientRouteHandler() {
  const searchParams = useSearchParams();
  const loginModal = useLoginModal();

  useEffect(() => {
    const loginFlag = searchParams.get("login");
    if (loginFlag === "1") {
      loginModal.open();
    }
  }, [searchParams]);

  return null; // Não renderiza nada
}
